import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AdminUser } from 'src/app/models/admin-users.model';
import { User } from 'src/app/models/users.model';
import { Conversion, ConversionShared } from 'src/app/models/conversion.model';
import { take } from 'rxjs/operators';
import firebase from 'firebase/compat/app';
const firestore = firebase.firestore;

import 'firebase/compat/firestore';
@Injectable({
  providedIn: 'root',
})
export class ConversionService {
  constructor(
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
  ) {}
  /**
   * Removes all files related to conversion from Storage and Firestore
   *
   * @param file Conversion
   * @param user User who is deleting
   * @returns Promise<void>
   */
  async deleteConversion(file: ConversionShared, user: User | AdminUser) {
    const update: Partial<Conversion> = {
      deleted: true,
      deletedByUserUid: user.uid,
      deletedByUserName: user.name,
      deletedDate: firestore.Timestamp.now(),
      healthCheck: null,
      // Links
      downloadUrl: null,
      csvDownloadLink: null,
      xlsxDownloadLink: null,
      oldCsvDownloadLink: null,
      oldXlsxDownloadLink: null,
    };

    const originalRef = file.downloadUrl ? this.storage.refFromURL(file.downloadUrl) : null;
    const csvDownloadRef = file.csvDownloadLink ? this.storage.refFromURL(file.csvDownloadLink) : null;
    const xlsxDownloadRef = file.xlsxDownloadLink ? this.storage.refFromURL(file.xlsxDownloadLink) : null;
    const oldCsvDownloadRef = file.oldCsvDownloadLink ? this.storage.refFromURL(file.oldCsvDownloadLink) : null;
    const oldXlsxDownloadRef = file.oldXlsxDownloadLink ? this.storage.refFromURL(file.oldXlsxDownloadLink) : null;

    await Promise.all([
      originalRef?.delete(),
      csvDownloadRef?.delete(),
      xlsxDownloadRef?.delete(),
      oldCsvDownloadRef?.delete(),
      oldXlsxDownloadRef?.delete(),
      this.afs.doc(`files/${file.uid}`).update(update),
    ]);

    return update;
  }
}
